module.exports = __webpack_public_path__ + "img/womens_sneakers.e3455498.webp";